export default __webpack_public_path__ + "static/media/BusTravelingBack.42d43476.svg";